import React from 'react';
import {setLoading} from "../store/reducers/modalToggler";
import {useDispatch} from "react-redux";
import Snackbar from '@mui/joy/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import Box from "@mui/joy/Box";

const Loader = () => {
    const dispatch = useDispatch()
    const closeLoading = () => {
        dispatch(setLoading(false))
    }
    return (
        <Snackbar
            variant="soft"
            open={true}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            startDecorator={<CircularProgress color="success" size={25} />}
            endDecorator={
                <Box sx={{cursor:'pointer'}} onClick={closeLoading}>
                    <CloseIcon/>
                </Box>
            }
        >
            Loading please wait
        </Snackbar>
    );
}

export default Loader;